import 'Shared/Skeleton/Skeleton.scss'

const MapLoading = () => <div className="w-100 skeleton-loading-img" />

export default MapLoading
